import script from "./sport-live-tv-sort-select.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-sort-select.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-sort-select.vue?vue&type=style&index=0&id=04c3367a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04c3367a"]])

export default __exports__